<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">机构会员</span>
      </div>
    </div>
    <div class="box"
         v-html="contents"></div>
  </div>
</template>

<script>
export default {
  name: 'usInfor',
  data () {
    return {
      contents: ''
    };
  },
  created () {
    this.GetNewInfoById(3165, 213)
  },
  methods: {
    GetNewInfoById (id, column_Type) {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetNewInfoById', {
          keyword: '',
          id: parseInt(id),
          parentID: 0,
          column_Type: parseInt(column_Type),
          pageIndex: 0,
          pageSize: 0
        })
        .then(res => {
          if (res.data.code == 200) {
            let newinfolist = res.data.data.gpSiteNewInfoViewsViews;
            if (newinfolist != null && newinfolist.length > 0) {
              _this.contents = newinfolist[0].contents
                .replace(/white-space:nowrap/g, 'white-space:pre-wrap')
                .replace(/<video /g, "<video @contextmenu.prevent='' ")
                .replace(/<audio /g, "<audio @contextmenu.prevent='' ")
                .replace(/[ \t]*width[ \t]*=[ \t]*[^ \t]+/ig, "")
                .replace(/[ \t]*height[ \t]*=[ \t]*[^ \t]+/ig, "")
            }
          }
        });
    },
  }
};
</script>

<style scoped>
.box {
    width: 973px;
}
</style>